import React from "react";
import { Button, Paper, Typography } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

export default function ArticleEmptyState({ onAdd }) {
    return (
        <Paper variant="outlined" sx={{ p: { xs: 3, md: 6 }, borderRadius: 4, textAlign: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
                Noch keine Artikel vorhanden
            </Typography>
            <Typography sx={{ mt: 1.5, opacity: 0.8 }}>
                Lege deinen ersten Artikel an – Preise, Steuer und Einheit frei wählbar.
            </Typography>
            <Button
                variant="contained"
                startIcon={<AddRoundedIcon />}
                onClick={onAdd}
                sx={{
                    mt: 3,
                    backgroundColor: "orange",
                    color: "#000",
                    fontWeight: 700,
                    "&:hover": { backgroundColor: "#ff9e1a" },
                }}
            >
                Artikel hinzufügen
            </Button>
        </Paper>
    );
}
